// export const SERVER = 'http://127.0.0.1:3000/api';
export const SERVER = 'https://bot.anp.lviv.ua/api';
